import { BaseClass } from '../base';

// export interface RecommendationShort {
//   currentDeadlineDate: string;
//   adjournedDate: string;
//   area: string;
//   createdOn: string;
//   assessmentCoordinator: string;
//   assessmentCoordinatorName: string;
//   auditDefinition: string;
//   amountCapex: number;
//   category: string;
//   date_settled: string;
//   settledDateFinally: string;
//   plant: string;
//   department: string;
//   id: string;
//   initialDeadline: string;
//   legalUnit: string;
//   shortRemarkToAssessor: string;
//   isSpecialAudit: string;
//   status: string;
//   title: string;
//   last_modifier_date: string;
//   createdBy: string;
// }

export class RecommendationShort extends BaseClass {
  /** "adjournedDate" */
  adjournedDate!: string;
  /** "amountCapex" */
  amountCapex!: number; // long? in C# maps to number in typescript
  /** "assessmentCoordinator" */
  assessmentCoordinator!: string;
  /** "assessmentCoordinatorName" */
  assessmentCoordinatorName!: string;
  /** "auditDefinition" */
  auditDefinition!: string;
  /** "auditId" */
  auditId!: string;
  /** "recommendationTitle" */
  recommendationTitle!: string;
  /** "auditor" */
  auditor!: string;
  /** "category" */
  category!: string;
  /** "currentDeadlineDate" */
  currentDeadlineDate!: string;
  /** "department" */
  department!: string;
  /** "initialDeadline" */
  initialDeadline!: string;
  /** "isSpecialAudit" */
  isSpecialAudit!: boolean;
  /** "legalUnit" */
  legalUnit!: string;
  /** "plant" */
  plant!: string;
  /** "priority" */
  priority!: number; // long? in C# maps to number in typescript
  /** "recommendationId" */
  recommendationId!: string;
  /** "settledDate" */
  settledDate!: string;
  /** "settledDateFinally" */
  settledDateFinally!: string;
  /** "shortRemarkToAssessor" */
  shortRemarkToAssessor!: string;
  /** "status" */
  status!: string;
  /** "title" */
  title!: string;
}

export class Recommendation extends BaseClass {
  /** "auditId" */
  auditId!: string;
  /** "auditDefinition" */
  auditDefinition!: string;
  /** "recommendationTitle" */
  recommendationTitle!: string;
  /** "title" */
  title!: string;
  /** "isSpecialAudit" */
  isSpecialAudit!: boolean;
  /** "plant" */
  plant!: string;
  /** "recommendationId" */
  recommendationId!: string;
  other_prolongations!: string;
  /** "priority" */
  priority!: number;
  /** "currentDeadlineDate" */
  currentDeadlineDate!: string;
  /** "status" */
  status!: string;
  /** "shortRemarkToAssessor" */
  shortRemarkToAssessor!: string;
  /** "assessmentCoordinator" */
  assessmentCoordinator!: string;
  /** "commentExecution" */
  commentExecution!: string;
  /** "amountCapex" */
  amountCapex!: number | null;
  /** "settledDate" */
  settledDate!: string;
  /** "settledBy" */
  settledBy!: string;
  /** "settledByName" */
  settledByName!: string;
  /** "settledDateFinally" */
  settledDateFinally!: string;
  /** "settledByFinally" */
  settledByFinally!: string;
  /** "settledByFinallyName" */
  settledByFinallyName!: string;
  /** "shortText1" */
  shortText1!: string;
  /** "shortText2" */
  shortText2!: string;
  /** "adjournedReason" */
  adjournedReason!: string;
  /** "adjournedDate" */
  adjournedDate!: string;
  /** "adjournedBy" */
  adjournedBy!: string;
  /** "adjournedByName" */
  adjournedByName!: string;
  /** "sequenceNumber1" */
  sequenceNumber1!: number;
  /** "sequenceNumber2" */
  sequenceNumber2!: number;
  /** "report_type_dafc" */
  reportTypeDAFC!: string;
  /** "isLegallyRequired" */
  isLegallyRequired!: boolean;
  /** "budget" */
  budget!: string;
  /** "initialDeadline" */
  initialDeadline!: string;
  /** "plantComments" */
  plantComments!: string;
  /** "category" */
  category!: string;
  /** "concernsName" */
  concernsName!: string;
  /** "concernsCountry" */
  concernsCountry!: string;
  /** "reportingYear" */
  reportingYear!: string;
  /** "legalUnit" */
  legalUnit!: string;
  /** "department" */
  department!: string;
  /** "auditor" */
  auditor!: string;
  /** "assessmentCoordinatorName" */
  assessmentCoordinatorName!: string;
  /** "legalUnitResponsibles" */
  legalUnitResponsibles!: string[];
  /** "legalUnitResponsiblesNames" */
  legalUnitResponsiblesNames!: string[];
  /** "emailAddress" */
  emailAddress!: string;
  /** "modificationAction" */
  modificationAction!: string[];
  /** "modificationDate" */
  modificationDate!: string[];
  /** "modificationStatus" */
  modificationStatus!: string[];
  /** "fileLinkId" */
  fileLinkId!: string;
  /** "settleRejectReason" */
  settledRejectReason!: string;
  /** "otherResponsiblesNames" */
  otherResponsiblesNames!: string[];
  /** "otherResponsibles" */
  otherResponsibles!: string[];
  /** "prolongationDecision" */
  prolongationDecision!: string;
  /** "prolongationStatus" */
  prolongationStatus!: string;
  /** "prolongationHistory" */
  prolongationHistory!: string[];
  /** "prolongationDeadline" */
  prolongationDeadline!: string;
  /** "prolongationRequestDate" */
  prolongationRequestDate!: string;
  /** "prolongationRequestBy" */
  prolongationRequestBy!: string;
  /** "prolongationRequestByName" */
  prolongationRequestByName!: string;
  /** "prolongationGrantedDate" */
  prolongationGrantedDate!: string;
  /** "prolongationGrantedBy" */
  prolongationGrantedBy!: string;
  /** "prolongationGrantedByName" */
  prolongationGrantedByName!: string;
  /** "prolong" */
  prolongation!: string;
  /** "prolongationOtherDate" */
  prolongationOtherDate!: string;
  /** "prolongationOtherHistory" */
  prolongationOtherHistory!: string;
  /** "prolongationToAssessor" */
  prolongationToAssessor!: string;
  otherProlongations!: string;
  responsibleAssessment!: string;
  /** "responsibleAssessmentName" */
  responsibleAssessmentName!: string;
  responsibleAssessmentAzureId!: string;
  legalUnitResponsiblesCc!: string[];
  /** "legalUnitResponsiblesCcNames" */
  legalUnitResponsiblesCcNames!: string[];
  legalUnitResponsiblesCcAzureIds!: string[];
  readOthersLegalUnit!: string[];
  /** "readOthersLegalUnitNames" */
  readOthersLegalUnitNames!: string[];
  readOthersLegalUnitAzureIds!: string[];

  /** "sendReminder0" */
  sendReminder0Days!: boolean;
  /** "sendReminder12Month" */
  sendReminder12Month!: boolean;
  /** "sendReminder14" */
  sendReminder14Days!: boolean;
  /** "sendReminder30before" */
  sendReminder30DaysBefore!: boolean;
  /** "sendReminder31" */
  sendReminder1Month!: boolean;
  /** "sendReminder3Month" */
  sendReminder3Month!: boolean;
  /** "SendReminderAll3Months" */
  sendReminderAll3Months!: number;
  authorsAuditor!: string;
  authorsBinGen!: string;
  authorsRec!: string;
  keypersons!: string[];
  myAttention!: string[];
  readersBusinessGroup!: string;
  readersLegalUnit!: string;
  readersResponsible!: string[];
  decision!: string;
  createdByUserId!: string;
  newDeadline!: string;
}
